import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function DefaultErrorComponent() {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasksAlerts.genericError"
    })
  });
}
export default DefaultErrorComponent;